import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { Check } from 'react-feather';
import { useFormContext } from 'react-hook-form';

import { VpHookFormInput, VpButton, VpIcon } from '../..';

export const PromoCodeInputs = ({ onApplyCode, plan }) => {
  const { getValues } = useFormContext();
  const couponApplied = plan?.couponApplied;

  const onClick = () => {
    onApplyCode(getValues()?.promoCode);
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        gap: '10px'
      }}
    >
      <VpHookFormInput maxLength={50} name="promoCode" placeholder="Promo Code" />
      <VpButton
        sx={{
          height: '40px',
          fontWeight: '500',
          fontSize: '16px'
        }}
        variant="contained"
        color="neutral"
        onClick={onClick}
      >
        {couponApplied ? (
          <>
            <VpIcon
              sx={{
                height: '16px',
                mr: '5px'
              }}
            >
              <Check />
            </VpIcon>{' '}
            Applied
          </>
        ) : (
          'Apply Code'
        )}
      </VpButton>
    </Box>
  );
};

PromoCodeInputs.propTypes = {
  onApplyCode: PropTypes.func,
  plan: PropTypes.object
};

export default PromoCodeInputs;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/stripe-elements/PromoCodeInputs.jsx